import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { FormattedMessage } from 'react-intl';
import { useCallback } from 'react';

import { Button } from 'ui-components/components/button';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { messages } from '../messages';
import style from '../define-shipments-table.module.less';

const ActionsCell = ({ row, onDeleteProduct }) => {
  const { productId, isHeader, boxConfigurationId, quantityPerBox, quantityRemaining, boxesPerConfig } = row?.original || {};

  const onClick = useCallback(() => {
    onDeleteProduct({
      boxConfigurationId,
      productId,
      quantityPerBox,
      quantityRemaining,
      boxesPerConfig,
    });
  }, [boxConfigurationId, onDeleteProduct, productId, quantityPerBox, quantityRemaining, boxesPerConfig]);

  if (isHeader) {
    return null;
  }

  return (
    <Button className={style['delete-button']} onClick={onClick} theme='unstyled'>
      <FontAwesomeIcon icon={faTrash} />
    </Button>
  );
};

export const createActionsColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'actions',
  Header: <FormattedMessage {...messages.actionsColumnHeader} />,
  Cell: ActionsCell,
  width: 1,
  className: style['actions-cell'],
});
